// extracted by mini-css-extract-plugin
export default {"timelineHead":"styles_timelineHead__xAzWT","timeHeadCell":"styles_timeHeadCell__+RtBl","timeAnnotation":"styles_timeAnnotation__JXxYt"};